import React from 'react';
import PropTypes from 'prop-types';
// import classnames from 'classnames';
import { Link } from 'react-router-dom';

export const FooterList = props => (
  <ul className={props.menuFooter ? 'menu-link' : 'menu'}>
    <li>
      <Link to="/">&copy; 2019 Treadie, Inc.</Link>
    </li>
    <li>
      <a
        href="https://twitter.com/treadieinc"
        target="_blank"
        rel="noopener noreferrer"
      >
        Twitter
      </a>
    </li>
    {/* <li>
			<Link to="/pricing">Pricing</Link>
</li> */}

    <li>
      <a href="mailto:info@treadie.com">Contact</a>
    </li>
    <li>
      <Link to="/terms">Terms</Link>
    </li>
    <li>
      <Link to="/privacy">Privacy</Link>
    </li>
  </ul>
);

FooterList.propTypes = {
  menuFooter: PropTypes.bool
};
